var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGasStationBlue(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5 14H0.5C0.21875 14 0 14.25 0 14.5V15.5C0 15.7812 0.21875 16 0.5 16H10.5C10.75 16 11 15.7812 11 15.5V14.5C11 14.25 10.75 14 10.5 14ZM15.4062 3.375L12.875 0.84375C12.6875 0.65625 12.3438 0.65625 12.1562 0.84375L11.8125 1.1875C11.625 1.375 11.625 1.6875 11.8125 1.90625L13 3.0625V5C13 5.90625 13.625 6.625 14.5 6.75V11.75C14.5 12.1875 14.1562 12.5 13.75 12.5C13.3125 12.5 13 12.1875 13 11.75V10.75C13 9.25 11.75 8 10.25 8H10V2C10 0.90625 9.09375 0 8 0H3C1.875 0 1 0.90625 1 2V13H10V9.5H10.25C10.9375 9.5 11.5 10.0625 11.5 10.75V11.625C11.5 12.8125 12.3438 13.875 13.5 14C14.8438 14.125 16 13.0938 16 11.75V4.78125C16 4.25 15.7812 3.75 15.4062 3.375ZM8 6H3V2H8V6Z",
    fill: "#005A8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGasStationBlue);
export default __webpack_public_path__ + "static/media/gasStationBlue.87def460a1fa19d8878d1b0eb9846059.svg";
export { ForwardRef as ReactComponent };